import { BaseStore } from '../App/Infrastructure/BaseStore';

export class CreateProductStore extends BaseStore {}

export default CreateProductStore;
